__turbopack_context__.v({
  "active": "CiCL3q_active",
  "cartCount": "CiCL3q_cartCount",
  "closeButton": "CiCL3q_closeButton",
  "container": "CiCL3q_container",
  "gradientText": "CiCL3q_gradientText",
  "logo": "CiCL3q_logo",
  "mainLinks": "CiCL3q_mainLinks",
  "menuToggle": "CiCL3q_menuToggle",
  "nav": "CiCL3q_nav",
  "navLink": "CiCL3q_navLink",
  "offerBanner": "CiCL3q_offerBanner",
  "open": "CiCL3q_open",
  "sidebar": "CiCL3q_sidebar",
  "sidebarBackdrop": "CiCL3q_sidebarBackdrop",
  "sidebarHeader": "CiCL3q_sidebarHeader",
  "sidebarLink": "CiCL3q_sidebarLink",
  "themeToggle": "CiCL3q_themeToggle",
  "userEmail": "CiCL3q_userEmail",
});
